import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { t } from "@/i18n/sk";
import { getExpansion, resolveImg } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { CardCard } from "@/components/CardCard";
import { HoloBackground } from "@/components/HoloBackground";

export default function ExpansionDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null); setNotFound(false);
    getExpansion(slug).then(setData).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="vault-bg mx-auto max-w-3xl px-4 py-32 text-center">
        <h1 className="font-display text-3xl font-bold text-white">Séria nenájdená</h1>
        <Link to="/serie" className="mt-6 inline-block text-cyan-300">← {t.nav.series}</Link>
      </div>
    );
  }

  const exp = data?.expansion;
  const products = data?.products || [];
  const cards = data?.cards || [];

  return (
    <div className="vault-bg">
      <section className="relative overflow-hidden border-b border-white/8">
        <div className="absolute inset-0">
          {exp?.image_url && <img src={resolveImg(exp.image_url)} alt="" className="h-full w-full object-cover opacity-25" />}
          <div className="absolute inset-0 bg-gradient-to-t from-vault-black via-vault-midnight/80 to-vault-black/50" />
        </div>
        <HoloBackground />
        <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <Link to="/serie" data-testid="back-to-series" className="mb-6 inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white"><ArrowLeft className="h-4 w-4" /> {t.nav.series}</Link>
          {exp && (
            <>
              <span className="overline mb-3 block">{exp.release_label || exp.series}</span>
              <h1 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{exp.name}</h1>
              <p className="mt-4 max-w-2xl text-slate-300">{exp.description}</p>
            </>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        {products.length === 0 && cards.length === 0 ? (
          <p className="py-16 text-center text-slate-400">V tejto sérii momentálne nie sú dostupné žiadne produkty.</p>
        ) : (
          <>
            {products.length > 0 && (
              <>
                <h2 className="mb-6 font-display text-xl font-bold text-white">Produkty · ETB a Boostre</h2>
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                  {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
                </div>
              </>
            )}
            {cards.length > 0 && (
              <>
                <h2 className="mb-6 mt-16 font-display text-xl font-bold text-white">{t.nav.cards}</h2>
                <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
                  {cards.map((c, i) => <CardCard key={c.id} card={c} index={i} />)}
                </div>
              </>
            )}
          </>
        )}
      </section>
    </div>
  );
}
